import { Row, Col, Checkbox, Input } from "components/common";
import React from "react";
import { Wrapper } from "./AddStatusModal.styled";


const AddStatusModal = ({ setformData, formData, editData }) => {
  return (
    <Wrapper>
      <Row gutter={[10, 20]} className="add-status-modal-row">
        <Col span={24}>
          <label htmlFor="" className="modal-label">
            Status Name
          </label>
          <Input
            type="text"
            placeholder="Enter status name"
            className="modal-input"
            value={formData?.name}
            onChange={(e) => {
              setformData({
                ...formData,
                name: e.target.value,
              });
            }}
          />
        </Col>
        <Col span={24}>
          <Checkbox
            checked={formData?.paymentTrigger}
            onChange={(e) => {
              setformData({
                ...formData,
                paymentTrigger: e.target.checked,
              });
            }}
          >
            Payment Trigger
          </Checkbox>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default AddStatusModal;
